<template>
  <div>
    <plan-notification-tray-item v-if="item.data.type === notificationTypes.PLAN" :item="item"/>
    <invoice-notification-tray-item v-else-if="item.data.type === notificationTypes.INVOICE" :item="item"/>
    <payment-confirm-notification-tray-item v-else-if="item.data.type === notificationTypes.PAYMENT_CONFIRM" :item="item"/>
    <submission-notification-tray-item v-else-if="item.data.type === notificationTypes.SUBMISSION" :item="item"/>
    <default-notification-tray-item v-else :item="item"/>
  </div>
</template>

<script>
import PlanNotificationTrayItem from "./PlanNotificationTrayItem.vue";
import DefaultNotificationTrayItem from "./DefaultNotificationTrayItem.vue";
import {NOTIFICATION_TYPES} from "../../../services/Defaults";
import InvoiceNotificationTrayItem from "./InvoiceNotificationTrayItem.vue";
import SubmissionNotificationTrayItem from "./SubmissionNotificationTrayItem.vue";
import PaymentConfirmNotificationTrayItem from "./PaymentConfirmNotificationTrayItem.vue";

export default {
  name: "NotificationTrayItem",
  props: {
    item: Object | Array
  },
  data() {
    return {
      notificationTypes: NOTIFICATION_TYPES
    }
  },
  components: {
    PaymentConfirmNotificationTrayItem,
    SubmissionNotificationTrayItem,
    InvoiceNotificationTrayItem,
    DefaultNotificationTrayItem,
    PlanNotificationTrayItem,
  },
}
</script>

<style scoped>

</style>
